import updateInformationGiftUtil from 'modules/gift/utils/update-information'
import getInformationGiftSelect from 'modules/gift/redux/selectors/get-information'
import logUtil from 'utils/log'
import shouldDeliverToRecipientGiftSelect from 'modules/gift/redux/selectors/should-deliver-to-recipient'
import updateShouldDeliverToRecipientGiftUtil from 'modules/gift/utils/update-should-delivery-to-recipient'

export default function persistInformationGiftAction () {
  return (dispatch, getState) => {
    const information = getInformationGiftSelect(getState()) || {}
    const shouldDeliverToRecipient = shouldDeliverToRecipientGiftSelect(getState())
    const debugProps = {
      information,
      shouldDeliverToRecipient
    }
    logUtil('persistInformationGiftAction').debug('[start] debugProps=', debugProps)
    updateInformationGiftUtil(JSON.stringify(information))
    updateShouldDeliverToRecipientGiftUtil(shouldDeliverToRecipient + '')
  }
}
